import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {oldInstance, instance} from './axios'// 自定义axios

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});


Vue.config.productionTip = false

//设置超时时间
// axios_def.defaults.timeout = 5000
// axios_def.defaults.baseURL = 'http://shkjgw.shkjem.com/api/'
//设置api地址
//全局定义axios
Vue.prototype.$http = oldInstance
Vue.prototype.http = instance

// 图片服务器地址
Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'

Vue.prototype.imgurl =  process.env.VUE_APP_API_BASE_URL + '/common/upload-file/'

Vue.prototype.convertEditorContent =  value => value.replace(new RegExp("{{imgurl}}",'g'), Vue.prototype.imgurl)
Vue.prototype.reverseConvertEditorContent =  value => value.replace(new RegExp(Vue.prototype.imgurl,'g'), "{{imgurl}}")

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 预渲染：等待数据加载完成后触发捕获事件
router.afterEach(() => {
  setTimeout(() => {
    document.dispatchEvent(new Event('prerender-ready'));
  }, 8000);
});